import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { IPromotionCouponDetail } from "interfaces";
import { endpointService } from "components/shared/services/endpointService";
import { ViewCouponDetail } from "components/shared/promotion/coupon/detail";
import Button from "components/button";
import { Link } from "react-router-dom";
import { PencilIcon } from "@heroicons/react/outline";
import { getFormattedDateTime, isHaveActionPermission } from "utills/helpers";
import { HistoryLogButton } from "components/historyLogButton";
import { Label } from "components/label";

export const PromotionCouponDetail: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const { data: couponDetail } = useOne<IPromotionCouponDetail>({
    resource: endpointService.getPromotionEndPoint("getCouponDetail", {
      couponId: params?.id,
    }),
    id: "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const couponDetailData = couponDetail?.data ?? null;

  return (
    <div className="wrapper">
      <Breadcrumbs
        additionalLabel={
          <div className="flex items-center gap-x-2.5">
            <HistoryLogButton
              resource={`promotion/coupons/${couponDetailData?.id}/history`}
              className="w-11 h-11"
            />
            {isHaveActionPermission("coupon", "promotion", "edit") ? (
              <div className="flex gap-x-2">
                <Link to={`/promotion/coupon/${couponDetailData?.id}/edit`}>
                  <Button className="w-11 h-11 sm:w-auto">
                    <span className="sr-only">Edit</span>
                    <PencilIcon className="w-4 h-4 text-white" />{" "}
                    <span className="hidden sm:block sm:ml-2">Edit</span>
                  </Button>
                </Link>
              </div>
            ) : (
              <></>
            )}
          </div>
        }
      />
      {couponDetailData ? (
        <>
          <ViewCouponDetail couponDetailData={couponDetailData} />
          {(couponDetailData?.created_by || couponDetailData?.created_at) && (
            <div className="box-container w-full">
              <div className="grid gap-x-4 gap-y-6 text-sm grid-cols-12 lg:gap-x-6">
                <div className="col-span-full sm:col-span-6">
                  <Label id="created_by" name="Created by" />
                  <p>{couponDetailData?.created_by}</p>
                </div>
                <div className="col-span-full sm:col-span-6">
                  <Label id="created_at" name="Created at" />
                  <p>{getFormattedDateTime(couponDetailData?.created_at)}</p>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
